import React from 'react';
import BoxStep from '../../../common/BoxStep';
import { getSelectedDays } from '../../../../redux/selectors/orderFormSelector';
import { parsePrice } from '../../../../utils';
import NextStepButton from '../../StepSelectDays/views/NextStepButton';
import { useAppSelector } from '../../../../config/hooks';
import {
  getChooseSideOrdersNumberOfSideOrders,
  getChooseSideOrdersPriceOfSideOrders,
} from '../../../../features/chooseSideOrders/chooseSideOrdersSelectors';
import useIsWide from "../../../../hooks/useIsWide";

const SideOrdersSummary = () => {
  const selectedDays = useAppSelector(getSelectedDays);
  const priceOfSideOrders = useAppSelector(
    getChooseSideOrdersPriceOfSideOrders
  );
  const numberOfSideOrders = useAppSelector(
    getChooseSideOrdersNumberOfSideOrders
  );

  const isMobile = useIsWide();

  return (
    <BoxStep smallPaddings title="Suma dodatków">
      <div className="steps-page__divide spacer-top-8" />
      <div className="display-flex justify-content-space-between align-items-center spacer-vertical-16">
        <p className="body-m color-gray-800">Liczba dni</p>
        <p className="label-m">{selectedDays.length}</p>
      </div>
      <div className="display-flex justify-content-space-between align-items-center spacer-vertical-16">
        <p className="body-m color-gray-800">Liczba dodatków</p>
        <p className="label-m">{numberOfSideOrders}</p>
      </div>
      <div className="steps-page__divide" />
      <div className="display-flex justify-content-space-between align-items-center spacer-vertical-16">
        <p className="body-m color-gray-800">Dodatki łącznie</p>
        <p className="label-m">{parsePrice(priceOfSideOrders)} zł</p>
      </div>
      {!isMobile && <NextStepButton/>}
    </BoxStep>
  );
};

export default SideOrdersSummary;
